import React, { Component } from 'react';
import LibraryCreateDialog from './LibraryCreateDialog';
import { connect } from 'react-redux';
const createLibraryRoute = 'media/:eventID/library/POST';
class LibraryCreateDialogContainer extends Component {
	onCreate = values => {
		const { event = {}, parentLibraryID, socket, auth0Token } = this.props;
		const library = {
			name: values.name,
			client_id: event.client_id,
			event_id: event.id,
			parent_library_id: parentLibraryID,
		};
		socket.emit(createLibraryRoute, library, values.groups, event.id, auth0Token);
		this.props.onCreate();
	};

	render() {
		return <LibraryCreateDialog {...this.props} onCreate={this.onCreate} />;
	}
}

const msp = ({ auth, ws }) => ({
	auth0Token: auth.auth0Token,
	socket: ws.socket,
});

export default connect(msp, null)(LibraryCreateDialogContainer);
